/** Shared shadcn Alert chrome for Trade Review + Preview trades. */

export const TRADE_REVIEW_ALERT_CLASS =
  "mb-3 rounded-lg font-[family-name:var(--font-primary)]";

export const TRADE_REVIEW_ALERT_TITLE_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-medium leading-5 text-foreground";

export const TRADE_REVIEW_ALERT_DESC_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal leading-5 text-gray-500 dark:text-white";
